import { atom } from "jotai";
import { User } from "../helpers/types";

export const userAtom = atom<User | null>(null);
